module.exports = __webpack_public_path__ + "static/media/gm.9c92221b.png";